import { AppDispatch } from "redux/store";
import { AppThunk, TRootState } from "redux/reducers/rootReducer";
import { parseResponse, IResponse } from "../resCheck";
import { getDataActionConstants } from "../dataActionConstants";
import { ITableData } from "types/backend_models/shared/ITableData";

export interface IGenericDataFetchParams<T>
{
	apiEndPoint: string,
	requestParams?: RequestInit
	pendingActionCreator: () => { type: string },
	succesActionCreator: (payload: { data: T }) => { type: string, payload: { data: T | null } },
	errorActionCreator: (payload: { error: string }) => { type: string, payload: { error: string } },
	succesDelay?: number,
	logResult?: boolean
}

/** Created to avoid code duplication */
export function createGenericDataFetch<T>(params: IGenericDataFetchParams<T>): AppThunk
{
	return function (dispatch: AppDispatch)
	{
		const dataConstants = getDataActionConstants();
		// console.log(dataConstants)
		let requestParams: RequestInit = {
			headers: dataConstants.headers
		}
		// Combine params
		if (params.requestParams) {
			requestParams = {
				...params.requestParams,
				headers: {
					...requestParams.headers,
					...params.requestParams.headers
				}
			}
		};

		let endPoint = params.apiEndPoint;
		if (endPoint.startsWith('/')) endPoint = endPoint.substring(1);

		dispatch(params.pendingActionCreator());
		fetch(`${dataConstants.serverRoot}/api/${endPoint}`, requestParams)
			.then((response: Response) => parseResponse<T>(response))
			.then((response: IResponse<T>) =>
			{
				if (params.logResult) console.log(`Response log ${response}`);
				if (response.ok) {
					if (params.succesDelay) {
						setTimeout(() =>
						{
							dispatch(params.succesActionCreator({
								data: response.json as T
							}));
						}, params.succesDelay ? params.succesDelay : 0);
					} else {
						dispatch(params.succesActionCreator({
							data: response.json as T
						}));
					}
				} else {
					switch (response.status) {
						case 404:
						case 400: {
							// Maybe someday?
							// dispatch(set404(response.error as string));
						}
					}

					throw Error(response.error);
				};
			})
			.catch((error: Error) =>
			{
				console.error(error.message);
				dispatch(params.errorActionCreator({ error: error.message }));
			})
	}
}

export function createGenericTableDataFetch<T>(params: IGenericDataFetchParams<ITableData<T>>): AppThunk
{
	return function (dispatch: AppDispatch, getState: () => TRootState)
	{
		const dataConstants = getDataActionConstants();
		// console.log({dataConstants})
		let requestParams: RequestInit = {
			headers: dataConstants.headers
		}
		// Combine params
		if (params.requestParams) {
			requestParams = {
				...params.requestParams,
				headers: {
					...requestParams.headers,
					...params.requestParams.headers
				}
			}
		};

		let endPoint = params.apiEndPoint;
		if (endPoint.startsWith('/')) endPoint = endPoint.substring(1);

		dispatch(params.pendingActionCreator());
		fetch(`${dataConstants.serverRoot}/api/${endPoint}`, requestParams)
			.then((response: Response) => parseResponse<T>(response))
			.then((response: IResponse<T>) =>
			{
				if (params.logResult) console.log(`Response log ${response}`);
				if (response.ok) {
					const tableData = response.json as ITableData<T>;
					if ((tableData.currentPage > tableData.pageCount) && (tableData.currentPage > 1)) {
						// VERY UGLY FIX -> REMOVE ONCE FIXED IN BACKEND
						// console.log('tableData.currentPage=', tableData.currentPage);
						let currentPageString = 'page=' + tableData.currentPage.toString();
						let newPageString = 'page=' + tableData.pageCount.toString();
						params.apiEndPoint = params.apiEndPoint.replace(
							currentPageString, newPageString
						);
						// console.log('params.apiEndPoint', params.apiEndPoint)
						// const fn = createGenericDataFetch(params);
						// fn(dispatch, getState, null);
					} else {
						if (params.succesDelay) {
							setTimeout(() =>
							{
								dispatch(params.succesActionCreator({
									data: tableData
								}));
							}, params.succesDelay ? params.succesDelay : 0);
						} else {
							dispatch(params.succesActionCreator({
								data: tableData
							}));
						}
					}
				} else {
					switch (response.status) {
						case 404:
						case 400: {
							// Maybe someday?
							// dispatch(set404(response.error as string));
						}
					}

					throw Error(response.error);
				};
			})
			.catch((error: Error) =>
			{
				console.error(error.message);
				dispatch(params.errorActionCreator({ error: error.message }));
			})
	}
}